import Vue from 'vue'

// 全局事件总线，用于跨组件通信
// 主要用途：语言切换时通知各页面重新加载数据
const EventBus = new Vue()

export default EventBus



// WEBPACK FOOTER //
// ./src/utils/eventBus.js